import {Button} from '@primer/react'
import {useViewer} from '@github-ui/item-picker-assignee-relay/useViewer'
import {useModifyAssignees} from '../../mutations/use-modify-assignees'
import styles from './AssignYourself.module.css'

export function AssignYourself() {
  const {mutate, isPending} = useModifyAssignees()
  const viewer = useViewer()

  if (!viewer) return <>No one assigned</>

  return (
    <>
      No one—
      <Button
        className={styles.assignYourselfButton}
        loading={isPending}
        variant="link"
        onClick={() =>
          mutate({
            addAssignees: [viewer.id],
            removeAssignees: [],
            nextAssignees: [viewer],
          })
        }
      >
        assign yourself
      </Button>
    </>
  )
}
